import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';
import { Layout } from '@components/layout'
// import {generatePath, matchPath} from 'react-router';
// import {CATALOG_ITEM, CATALOG_LIST} from '~/router/routes';
// import {history} from '~/router/history';

// function* redirectToCatalog() {
//     let { params } = matchPath(window.location.pathname, {
//         path: CATALOG_ITEM
//     });
//     yield history.push(generatePath(CATALOG_LIST, params));
// }

function* rootSagas() {
    // yield takeEvery([types.CATALOG_PRODUCT_DOWNGRADE_SUCCESS], redirectToCatalog);
    //
    // yield takeEvery([
    //     types.CATALOG_LIST_REQUEST,
    //     types.COLLECTIONS_ADD_PRODUCT_REQUEST,
    //     types.COLLECTIONS_REMOVE_PRODUCT_REQUEST,
    //     types.CATALOG_PRODUCT_DETAILS_REQUEST,
    //     types.CATALOG_PRODUCT_DOWNGRADE_REQUEST,
    // ], (Layout.actions.preloaderShow));
    // yield takeEvery([
    //     types.CATALOG_LIST_SUCCESS,
    //     types.CATALOG_LIST_FAILURE,
    //     types.COLLECTIONS_ADD_PRODUCT_SUCCESS,
    //     types.COLLECTIONS_ADD_PRODUCT_FAILURE,
    //     types.COLLECTIONS_REMOVE_PRODUCT_SUCCESS,
    //     types.COLLECTIONS_REMOVE_PRODUCT_FAILURE,
    //     types.CATALOG_PRODUCT_DETAILS_SUCCESS,
    //     types.CATALOG_PRODUCT_DETAILS_FAILURE,
    //     types.CATALOG_PRODUCT_DOWNGRADE_SUCCESS,
    //     types.CATALOG_PRODUCT_DOWNGRADE_FAILURE,
    // ], (Layout.actions.preloaderHide));
    yield takeEvery([
        types.GET_CHARACTERISTIC_GROUPS_DETAILS_SUCCESS,
        types.GET_CHARACTERISTIC_GROUPS_LIST_FAILURE,
    ], (Layout.actions.closePreloaderSaga));
}

export default rootSagas;
